import { AxiosResponse } from "axios";
import { BaseCompany } from "./bases/base.service";

export default class CompanyService {
  public login(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCompany().post("auth/login", params);
  }
  public request(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCompany().post("auth/request", params);
  }
  public reset(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseCompany().post("auth/reset", params);
  }
}
